import React from "react";
import { Panel } from "rsuite";
import Settings from "./Settings";

const Page = () => {
  return (
    <Panel header={<h3 className="title">Settings</h3>}>
      <Settings />
    </Panel>
  );
};

export default Page;
